import { render, staticRenderFns } from "./listado.vue?vue&type=template&id=2e88ae1b"
import script from "./listado.vue?vue&type=script&lang=js"
export * from "./listado.vue?vue&type=script&lang=js"
import style0 from "./listado.vue?vue&type=style&index=0&id=2e88ae1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports